// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoLinksSearchStyles } from "@cahaba/Overrides/Widgets/Header/LogoLinksSearch";
import baseTheme from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

logoLinksSearchStyles.container = {
    css: css`
        display: flex;
        flex: 0 0 100%;
        margin: 0 auto;
        flex-wrap: wrap;
        ${({ theme }) => {
            const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
            return breakpointMediaQueries(theme, [
                css`
                    max-width: ${maxWidths[0]}px;
                    flex-wrap: wrap;
                    padding: 0 15px;
                `,
                css`
                    max-width: ${maxWidths[1]}px;
                    flex-wrap: wrap;
                    padding: 0 15px;
                `,
                css`
                    max-width: ${maxWidths[2]}px;
                    flex-wrap: wrap;
                    padding: 0 15px;
                `,
                css`
                    max-width: ${maxWidths[3]}px;
                    padding: 0 60px;
                `,
                css`
                    max-width: ${maxWidths[4]}px;
                    padding: 0 60px;
                `,
            ]);
        }}
        margin: 0 auto;
        align-items: center;
    `,
};

logoLinksSearchStyles.parentContainer = {
    css: css`
        background-color: ${getColor("common.background")};
        display: flex;
        flex-wrap: wrap;
        padding: 10px 0;
    `,
};

logoLinksSearchStyles.mainNavigationWrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex: 1 0 auto;
        padding: 0;
        width: 100%;
    `,
};

logoLinksSearchStyles.headerActionsContainer = {
    css: css`
        flex: 0 0 33.3%;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    text-align: center;
                    flex: 0 0 100%;
                    display: flex;
                    justify-content: center;
                `,
                css`
                    text-align: center;
                    flex: 0 0 100%;
                    display: flex;
                    justify-content: center;
                `,
                css`
                    text-align: center;
                    flex: 0 0 100%;
                    display: flex;
                    justify-content: center;
                `,
                css``,
                css``,
            ]);
        }}
    `,
};

logoLinksSearchStyles.searchContainer = {
    css: css`
        padding-right: 30px;
        flex: 0 0 33.3%;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                css``,
                css``,
            ]);
        }}
    `,
};

logoLinksSearchStyles.secondaryNavigation = {
    css: css`
        margin: auto;
        padding: 7px 60px 7px 60px;
        ${({ theme }) => {
            const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
            return breakpointMediaQueries(theme, [
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                css`
                    max-width: ${maxWidths[3]}px;
                `,
                css`
                    max-width: ${maxWidths[4]}px;
                `,
            ]);
        }}
    `,
};

logoLinksSearchStyles.cartContainer = {
    css: css`
        flex: 0 0 33.3%;
    `,
};

logoLinksSearchStyles.secondaryNavigationContainer = {
    css: css`
        max-width: none;
        width: 100%;
        background-color: ${getColor("secondary.main")};
    `,
};

logoLinksSearchStyles.mainNavParentContainer = {
    css: css`
        max-width: none;
        width: 100%;
        border-bottom: 1px solid ${getColor("common.border")};
        padding: 7.5px 0;
        background: ${getColor("primary.main")};
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css``,
                css``,
                css``,
                css`
                    box-shadow: inset 0 7px 9px -7px rgba(0, 0, 0, 0.4);
                    background: none;
                `,
                css`
                    box-shadow: inset 0 7px 9px -7px rgba(0, 0, 0, 0.4);
                    background: none;
                `,
            ]);
        }}
    `,
};
